import { render, staticRenderFns } from "./CallTag.vue?vue&type=template&id=5bbd5b73"
import script from "./CallTag.vue?vue&type=script&lang=js"
export * from "./CallTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports